import { FC, useContext, useState } from 'react';
import Link from 'next/link';
import { MobileMenuContext } from 'components/commercetools-ui/organisms/header/header-navigation/context/mobile-menu-context';
import ForwardIcon from 'icons/forward';
import { AmplienceMegaNavProps } from '.';
import AmplienceNavColumnMobile from '../nav-column/nav-column-mobile';
import { gtmMenuNavigation } from 'helpers/utils/gtm-events/gtmInteraction';

export interface AmplienceMegaNavMobileProps extends AmplienceMegaNavProps {
  includeHeader?: boolean;
  navColumnClassName?: string;
}

const AmplienceMegaNavMobile: FC<AmplienceMegaNavMobileProps> = ({
  link,
  navColumns,
  title,
  includeHeader = true,
  navColumnClassName,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const handleItemClick = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  return (
    <>
      {includeHeader && <Header link={link || ''} title={title} />}
      <ul className="overflow-auto">
        {navColumns &&
          navColumns.length > 0 &&
          navColumns.map((navColumn, idx) => (
            <AmplienceNavColumnMobile
              key={`nav-column-mobile-${navColumn.mainTitle}-${idx}`}
              {...navColumn}
              isOpen={activeIndex === idx}
              onClick={() => handleItemClick(idx)}
              className={navColumnClassName}
            />
          ))}
      </ul>
    </>
  );
};

const Header: FC<Pick<AmplienceMegaNavProps, 'link' | 'title'>> = ({ link, title }) => {
  const { setMegaNavSelected } = useContext(MobileMenuContext);
  return (
    <div className="flex h-[54px] w-full items-center justify-between border border-black/10 bg-primary-cream px-4">
      <div className="flex items-center gap-4" onClick={() => setMegaNavSelected(undefined)}>
        <ForwardIcon className="rotate-180" />
        <p className="text-sm font-semibold leading-[17px] text-[#222222]">{title}</p>
      </div>
      <Link
        onClick={() => {
          gtmMenuNavigation({ click_location: 'header', click_name: 'Explore All' });
        }}
        className="text-sm font-semibold leading-[17px] text-[#222222]"
        href={link || ''}
        aria-label="Explore All"
      >
        Explore All
      </Link>
    </div>
  );
};

export default AmplienceMegaNavMobile;
